export enum LeadTopicType {
    PARKING = "PARKING",
    CUSTOM = "CUSTOM"
}
export enum LeadTopicType {
    PARKING = "PARKING",
    CUSTOM = "CUSTOM"
}
